<template>
  <div class="animated fadeIn">
    <Row>
      <Input v-model="keywordFilter" placeholder="名称/联系电话/联系地址" style="width: 200px; margin-right: 10px;"></Input>
      <Button type="primary" style="margin-right: 10px;" @click="onFilterClick">查询</Button>
      <Button type="primary" @click="addVehicleInfoModal=true">添加车辆信息</Button>
    </Row>
    <Row style="margin-top: 10px;">
      <div>
        <div style="position:relative;">
          <Table size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page :total="totalElements" :page-size="pageSize" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:10px;"></Page>

      </div>
    </Row>
    <add-vehicle-info-modal v-model="addVehicleInfoModal" @on-success="onSuccess"></add-vehicle-info-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onSuccess"></vehicle-info-detail-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
    <check-vehicle-info-modal v-model="checkVehicleInfoModal" :initValue="checkVehicleInfoId"
                              @on-success="onSuccess"></check-vehicle-info-modal>
  </div>
</template>

<script>
import AddVehicleInfoModal from '@/view/components/add-vehicle-info-modal'
import VehicleInfoDetailModal from '@/view/components/vehicle-info-detail-modal'
import VehiclePictureModal from '@/view/components/vehicle-picture-modal'
import CheckVehicleInfoModal from '@/view/components/check-vehicle-info-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else {
    return '#000000'
  }
}

function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'vehicleinfos',
  components: {
    VehiclePictureModal,
    AddVehicleInfoModal,
    VehicleInfoDetailModal,
    CheckVehicleInfoModal
  },
  data () {
    return {
      vehicleBrandOptions: [],
      vehicleTypeOptions: [],
      engineBrandOptions: [],

      vehicleBrandFilter: null,
      vehicleTypeFilter: null,
      engineBrandFilter: null,
      emissionStandardFilter: null,

      businessStateFilter: null,

      // 审核车辆信息
      checkVehicleInfoModal: false,
      checkVehicleInfoId: null,

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 添加收入项
      addVehicleInfoModal: false,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 80
        },
        {
          title: '档案编号',
          key: 'fileNum',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '车架号',
          key: 'vin',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '汽车品牌',
          key: 'vehicleBrandId',
          ellipsis: 'true',
          minWidth: 140,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.vehicleBrandFilter = []
              val.forEach(item => {
                this.vehicleBrandFilter.push(genQueryParam('vehicleBrandId', 'EQ', item))
              })
            } else {
              this.vehicleBrandFilter = null
            }
          },
          render: (h, params) => {
            return h('label', params.row.vehicleBrand.name)
          }
        },
        {
          title: '汽车类型',
          key: 'vehicleTypeId',
          ellipsis: 'true',
          minWidth: 140,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.vehicleTypeFilter = []
              val.forEach(item => {
                this.vehicleTypeFilter.push(genQueryParam('vehicleTypeId', 'EQ', item))
              })
            } else {
              this.vehicleTypeFilter = null
            }
          },
          render: (h, params) => {
            return h('label', params.row.vehicleType.name)
          }
        },
        {
          title: '发动机品牌',
          key: 'engineBrandId',
          ellipsis: 'true',
          minWidth: 140,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.engineBrandFilter = []
              val.forEach(item => {
                this.engineBrandFilter.push(genQueryParam('engineBrandId', 'EQ', item))
              })
            } else {
              this.engineBrandFilter = null
            }
          },
          render: (h, params) => {
            return h('label', params.row.engineBrand.name)
          }
        },
        {
          title: '排放标准',
          key: 'emissionStandard',
          ellipsis: 'true',
          minWidth: 160,
          filters: [
            { label: '国二', value: '国二' },
            { label: '国三', value: '国三' },
            { label: '国四', value: '国四' },
            { label: '国五', value: '国五' },
            { label: '国六', value: '国六' }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.emissionStandardFilter = []
              val.forEach(item => {
                this.emissionStandardFilter.push(genQueryParam('emissionStandard', 'LIKE', '%25' + item + '%25'))
              })
            } else {
              this.emissionStandardFilter = null
            }
          }
        },
        {
          title: '驱动',
          ellipsis: 'true',
          minWidth: 160,
          render: (h, params) => {
            return h('label', params.row.engineBrand.name)
          }
        },
        {
          title: '行驶里程',
          sortable: 'custom',
          key: 'mileage',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '售价',
          sortable: 'custom',
          key: 'totalPrice',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '上牌时间',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'vehicleLicenseDistributeDatetime',
          minWidth: 180,
          render: function (h, params) {
            if (params.row.vehicleLicenseDistributeDatetime) {
              let d = new Date(params.row.vehicleLicenseDistributeDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '业务状态',
          key: 'businessState',
          ellipsis: 'true',
          minWidth: 160,
          filters: [
            { label: '草稿', value: 1 },
            { label: '添加待审核', value: 2 },
            { label: '修改待审核', value: 3 },
            { label: '正常', value: 4 },
            { label: '审核不通过', value: 5 },
            { label: '下架', value: 6 },
            { label: '作废', value: 7 },
            { label: '已售', value: 8 },
            { label: '修改草稿', value: 9 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.businessStateFilter = []
              val.forEach(item => {
                this.businessStateFilter.push(genQueryParam('businessState', 'EQ', item))
              })
            } else {
              this.businessStateFilter = null
            }
          },
          render: (h, params) => {
            if (params.row.businessState) {
              const state = params.row.businessState
              if (state === 1) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'orange'
                    }
                  }, '草稿')
                ])
              } else if (state === 2) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'blue'
                    }
                  }, '添加待审核')
                ])
              } else if (state === 3) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'blue'
                    }
                  }, '修改待审核')
                ])
              } else if (state === 4) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'green'
                    }
                  }, '正常')
                ])
              } else if (state === 5) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'red'
                    }
                  }, '审核不通过')
                ])
              } else if (state === 6) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'red'
                    }
                  }, '下架')
                ])
              } else if (state === 7) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'red'
                    }
                  }, '作废')
                ])
              } else if (state === 8) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'red'
                    }
                  }, '已售')
                ])
              } else if (state === 9) {
                return h('div', [
                  h('Tag', {
                    props: {
                      color: 'orange'
                    }
                  }, '修改草稿')
                ])
              }
            }
          }
        },
        {
          title: '创建时间',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          minWidth: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          fixed: 'right',
          ellipsis: 'true',
          minWidth: 400,
          render: (h, params) => {
            let display = []
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.id
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '详细信息')
            )
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehiclePictureId = params.row.id
                    this.vehiclePictureModal = true
                  }
                }
              }, '图片管理')
            )
            if (params.row.businessState === 1 || params.row.businessState === 9) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认提交审核',
                        content: '<p>确认提交审核</p>',
                        onOk: () => {
                          store.dispatch('VehicleInfoServ_Submit', {
                            params: { id: params.row.id }
                          }).then(() => {
                            this.$Message.success('提交成功')
                            this.onSuccess()
                          }).catch(err => {
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {

                        }
                      })
                    }
                  }
                }, '提交审核')
              )
            }
            if (params.row.businessState === 2 || params.row.businessState === 3) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.checkVehicleInfoId = params.row.id
                      this.checkVehicleInfoModal = true
                    }
                  }
                }, '审核')
              )
            }
            return h('div', display)
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'VehicleInfoServ_GetPage'
    ]),
    onSuccess () {
      this.setPage(1)
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    filterChange () {
      this.setPage(1)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true
      let qo1 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let qo6 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      if (this.businessStateFilter) {
        qo1 = this.businessStateFilter
      }
      if (this.vehicleBrandFilter) {
        qo3 = this.vehicleBrandFilter
      }
      if (this.vehicleTypeFilter) {
        qo4 = this.vehicleTypeFilter
      }
      if (this.engineBrandFilter) {
        qo5 = this.engineBrandFilter
      }
      if (this.emissionStandardFilter) {
        qo6 = this.emissionStandardFilter
      }

      store.dispatch('VehicleInfoServ_GetPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          qo6: qo6,
          q: queryParams,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_VehicleInfo_GetPageResult) {
        return store.getters.get_VehicleInfo_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_VehicleInfo_GetPageResult) {
        return store.getters.get_VehicleInfo_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_VehicleInfo_GetPageResult) {
        return store.getters.get_VehicleInfo_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('VehicleBrandServ_GetAll', {
        params: null,
        urlparams: null
      }).then(() => {
        this.vehicleBrandOptions = store.getters.get_VehicleBrand_GetAllResult.map(item => {
          return { label: item.name, value: item.id }
        })
        this.columns[3].filters = this.vehicleBrandOptions
      }).catch(err => {

      })

      store.dispatch('VehicleTypeServ_GetAll', {
        params: null,
        urlparams: null
      }).then(() => {
        this.vehicleTypeOptions = store.getters.get_VehicleType_GetAllResult.map(item => {
          return { label: item.name, value: item.id }
        })
        this.columns[4].filters = this.vehicleTypeOptions
      }).catch(err => {

      })

      store.dispatch('EngineBrandServ_GetAll', {
        params: null,
        urlparams: null
      }).then(() => {
        this.engineBrandOptions = store.getters.get_EngineBrand_GetAllResult.map(item => {
          return { label: item.name, value: item.id }
        })
        this.columns[5].filters = this.engineBrandOptions
      }).catch(err => {

      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 230
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 230
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
